<template>
  <div>
    <b-row>
      <b-col cols="8">
        <b-form-group label="Benefício:">
          <b-form-input
            v-model="beneficio.beneficio"
            placeholder="Benefício"
            :state="validateState('beneficio')"
          />
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group label="Valor de repasse:">
          <NumberFormat
            v-model="beneficio.repasse"
            placeholder="Valor de repasse"
            :state="validateState('repasse')"
          />
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <b-form-group label="Descrição:">
          <b-form-textarea
            v-model="beneficio.descricao"
            placeholder="Insira a descrição do benefício se necessáio..."
          />
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import NumberFormat from "@/components/Form/NumberFormat.vue";

export default {
  mixins: [validationMixin],
  components: { NumberFormat },

  props: {
    value: {},
  },
  data: () => ({
    beneficio: {
      beneficio: "",
      descricao: "",
      repasse: "",
    },
  }),
  validations: {
    beneficio: {
      beneficio: {
        required,
      },
      repasse: {
        required,
      },
    },
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.beneficio[name];
      return $dirty ? !$error : null;
    },
    isValid() {
      this.$v.beneficio.$touch();
      return !this.$v.beneficio.$anyError;
    },
    save() {
      if (!this.isValid()) {
        this.$notifications.addNotification({
          message: "Os dados do formulário são inválidos",
          type: "danger",
        });

        return null;
      }
      return this.beneficio;
    },
  },

  created() {
    if (this.value) {
      this.beneficio = JSON.parse(JSON.stringify(this.value));
    }
  },
};
</script>

<style>
</style>
